const ELEMENTS_PER_PAGE = process.env.REACT_APP_ELEMENTS_PER_PAGE;
const API_URL_ZOLOTIY_VIK = process.env.REACT_APP_API_QUERY_URL_ZV;
const API_URL_UKR_ZOLOTO = process.env.REACT_APP_API_QUERY_URL_URKZOLOTO;

export const UkrZolotoBrandName = 'ukrzoloto';
export const ZolotiyVikBrandName = 'zolotiyvik';

export const getBaseURL = (brandName) => {
    if (brandName === ZolotiyVikBrandName) {
        return API_URL_ZOLOTIY_VIK;
    } else if (brandName === UkrZolotoBrandName) {
        return API_URL_UKR_ZOLOTO;
    }

    throw new Error(`Unknown brand name: ${brandName}`);
}

export const isValidOption = (option) => {
    return option !== "" && option !== null;
}

export const identifyNumber = (num) => {
    let word = '';
    let lastDigit = num % 10;
    let lastTwoDigits = num % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        word = 'товарів';
    } else if (lastDigit === 1) {
        word = 'товар';
    } else if (lastDigit >= 2 && lastDigit <= 4) {
        word = 'товари';
    } else {
        word = 'товарів';
    }
    return word;
}

export const pageCounter = (count) => {
    if (!count || isNaN(count)) return 1;
    return Math.ceil(count / ELEMENTS_PER_PAGE);
}

export const countOffset = (value) => {
    return value * ELEMENTS_PER_PAGE - ELEMENTS_PER_PAGE;
}

export const handleScrollUp = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

export const objectAlphabetSort = (obj) => {
    Object.keys(obj).forEach(key => {
        obj[key].sort();
    });
}

export const getDomainFromUrl = (url) => {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname;
}
